let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("evWu5")).then(() => parcelRequire('8foBH'));